"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputProvider = void 0;
class KHInputProvider {
    /**
     * Attempt to vibrate the input source.
     * @param duration Duration in millis
     * @param weak Magnitude of weak rumble (0-1)
     * @param strong Magnitude of strong rumble (0-1)
     */
    tryVibrate(duration, weak, strong) {
        // Default is no implementation.
    }
    type() {
        return null;
    }
    getId() {
        return "";
    }
}
exports.KHInputProvider = KHInputProvider;
